//import { renderFlagCheckIfStmt } from '@angular/compiler/src/render3/view/template';
import { Injectable, Injector } from '@angular/core';
import { ExceptionDetails } from '../_models/exception-details';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorDiagnosticService {
  
  private _details: ExceptionDetails;

  constructor() 
  {
    this._details = new ExceptionDetails();
  }

  public setUser(userName:string){
    this._details.user = userName;
  }

  public setLocation(locationName:string) {
    this._details.location = locationName;
  }

  public setMethodName(methodName:string){
    this._details.method = methodName;
    this._details.trace = [];
  }

  public setDocumentsId(documentsId:string[]){
    this._details.documentsId = documentsId;
  }

  public setTrace(trace:string){
    this._details.trace.push( trace);
  }

  public getDetails(){
    return this._details;
  }
}
